import * as React from 'react';
import styles from './riskQuestion.module.css';

import { BackNextSkip, Radiobutton } from '@assetmark/common-elements/';
import { ERiskPageType } from '../../models/riskPageType';
import { TRiskProfile } from '../../models/riskProfile.model';
import { countMaxDecline, formatLabel } from './riskQuestionHelper';
import { TQuestionData } from '../../models/riskQuestion.model';

export interface TRiskQuestionsProps {
  investmentAmount?: number;
  backButtonClassName?: string;
  nextButtonClassName?: string;
  riskProfiles?: TRiskProfile[];
  onBackButtonClick: (event: any, componentData: TQuestionData) => void;
  onNextButtonClick: (event: any, componentData: TQuestionData) => void;
  onSkipButtonClick?: (event: any, componentData: TQuestionData) => void;
  data: TQuestionData;
  highlighted?: boolean;
  highlightedRiskQuestions?: number;
}

export interface TRiskQuestionsState {
  selectedChoiceId: number;
  data: TQuestionData;
  riskProfiles: TRiskProfile[];
}

export class RiskQuestionsComponent extends React.Component<
  TRiskQuestionsProps,
  TRiskQuestionsState
> {
  constructor(props?: TRiskQuestionsProps, context?: any) {
    super(props, context);
    this.state = {
      selectedChoiceId: this.props.data.selectedChoiceId
        ? this.props.data.selectedChoiceId
        : 0,
      data: this.props.data,
      riskProfiles: this.props.riskProfiles,
    };
  }

  componentWillUnmount() {
    // console.log('Resk Question Unmount');
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data.sequence !== this.props.data.sequence) {
      this.setState({ data: nextProps.data });
    }
  }

  render() {
    const {
      investmentAmount,
      backButtonClassName,
      nextButtonClassName,
      onBackButtonClick,
      onNextButtonClick,
      riskProfiles,
      highlighted,
      highlightedRiskQuestions,
    } = this.props;
    const { data } = this.state;
    const choices = data && data.choices ? data.choices : [];
    const isDisable = !data.selectedChoiceId ? true : false;

    return (
      <div className={`${styles.riskQuestion} col-sm-12`}>
        <h1 className={styles.riskQuestionHeading}> {data.heading} </h1>
        <div className={`row`}>
          <div className={`col-sm-12`}>
            <p className={styles.riskQuestionQuestionText}>{data.question}</p>
            <ul
              className={styles.riskQuestionQuestionOptions}
              style={{ listStyle: 'none' }}
            >
              {data.sequence === ERiskPageType.YourRiskProfile
                ? riskProfiles.map((riskProfile: TRiskProfile) => {
                    return (
                      <div
                        className={`${styles.riskQuestionQuestionOptions} ${highlighted &&
                          riskProfile.RiskProfileID <=
                            highlightedRiskQuestions &&
                          'highlighted'}`}
                        key={riskProfile.RiskProfileID}
                      >
                        <Radiobutton
                          name="risk-tolerance"
                          value={riskProfile.RiskProfileID}
                          isChecked={
                            Number(data.selectedChoiceId) ===
                            riskProfile.RiskProfileID
                          }
                          onChange={this.onRadioChange}
                        >
                          {`${riskProfile.RiskProfileName} ${riskProfile.RiskProfileType}`}
                        </Radiobutton>
                      </div>
                    );
                  })
                : choices.map((ch) => {
                    let label;
                    switch (data.sequence) {
                      case Number([ERiskPageType.MaximumDecline]):
                        label = formatLabel(
                          countMaxDecline(
                            investmentAmount,
                            parseFloat(ch.choice),
                          ),
                        );
                        break;
                      default:
                        label = ch.choice;
                    }
                    return (
                      <li
                        key={ch.choiceId}
                        className={styles.riskQuestionQuestionOptions}
                      >
                        <Radiobutton
                          name="risk-tolerance"
                          value={ch.choiceId}
                          isChecked={
                            data.selectedChoiceId === Number(ch.choiceId)
                          }
                          onChange={this.onRadioChange}
                          labelStyle="labelStyle"
                        >
                          {label}
                        </Radiobutton>
                      </li>
                    );
                  })}
            </ul>
            <div className={styles.riskQuestionButtons}>
              <BackNextSkip
                backButtonClassName={backButtonClassName}
                onBackButtonClickHandler={(e) => onBackButtonClick(e, data)}
                nextButtonClassName={nextButtonClassName}
                onNextButtonClickHandler={(e) => onNextButtonClick(e, data)}
                isDisabledNextButton={isDisable}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  onRadioChange = (event: any) => {
    const data = {
      ...this.state.data,
      selectedChoiceId: Number(event.target.value),
    };
    this.setState({ data });
  };
}
